"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.InvestorsMenuEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var entity_factory_1 = require("./entity-factory");
exports.InvestorsMenuEntity = entity_factory_1.entityFactory(types_1.DocumentType.INVESTORS_MENU, function (prismicDoc, normalizedEntity, logger) {
    var _a, _b;
    return utils_1.compact(__assign(__assign({}, normalizedEntity), { uid: types_1.DocumentType.INVESTORS_MENU, type: types_1.DocumentType.INVESTORS_MENU, items: (_b = (_a = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _a === void 0 ? void 0 : _a.menu_items) === null || _b === void 0 ? void 0 : _b.map(function (dataItem) {
            if (dataItem.label && dataItem.link) {
                return {
                    label: logger.required(fields_1.toText(dataItem.label)),
                    link: logger.required(fields_1.toLink(dataItem.link, logger))
                };
            }
            return undefined;
        }).filter(Boolean) }));
});
//# sourceMappingURL=investors-menu.js.map